// extracted by mini-css-extract-plugin
export default {"hero-nav":"Header_hero-nav__6I3UZ","hero-logo":"Header_hero-logo__ZIpQt"};